import React, { useState, useEffect } from "react";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import ListFilters from "../../../Admin/OnBoardManagement/ListFilters";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";

// Un-Checkbox.svg

const PaymentInvoiceList = () => {
  const [jobCardInvoiceData, setJobCarInvoiceData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [totalRecords, setTotalRecored] = useState(0);
  const [totalPaymentInvoice, setTotalPaymentInvoice] = useState(null);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const [lodertable,setLoderTable] = useState(false)

  // useEffect(() => {
  //   fetchBusinessPartners();
  // }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // fetchBusinessPartners(newPage);
  };

  // const handleSearchInputChange = (event) => {
  //     setSearchTerm(event.target.value);
  // };

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map((header) => keyMapping[header]);
    const csvRows = data.map((item) => {
      return headers
        .map((header) => {
          const key = keyMapping[header];
          return item[key];
        })
        .join(",");
    });
    const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
    return csvContent;
  };

  const handleEdit = (rowData) => {
    navigate("payment-invoice-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const fetchJobCardInvoiceList = async (page = 0, pageSize = 10) => {
    const allFilter = filters;
    const payload=   {
      orderBy: "job_card_id desc",
      page,
      pageSize,
      fromDate: allFilter?.fromDate ? allFilter?.fromDate : "",
      toDate: allFilter?.toDate ? allFilter?.toDate : "",
      business_partner_id: 1,
      searchText: searchTerm,
    }
    try {
      setLoderTable(true)
      const response = await axiosInstance.post(
        "/jobcardinvoicepayment/list",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoderTable(false)
      const formattedData = response.data.data.data?.map((item, index) => ({
        ...item,
        Sr_No: index + 1,
        Payment_Status: item?.payment_status === 0 ? "Pending" : "Done",
        amount: <div>&#8377; {item?.total_amount}</div>,
      }));
      setJobCarInvoiceData(formattedData);
      setTotalRecored(response?.data?.data?.totalRecords);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalPaymentInvoice(response?.data?.data);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const Job_Card_TABLE_HEADERS = [
    "Invoice No.",
    "Job Card No.",
    "Customer Name",
    "Job Type",
    "Registration No.",
    "Total Amt.",
    "Status",
    "Action",
  ];

  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Invoice No.": "invoice_no",
    "Job Card No.": "job_card_no",
    "Customer Name": "customer_name",
    "Job Type": "job_type",
    "Registration No.": "registration_no",
    "Total Amt.": "amount",
    Status: "Payment_Status",
    Action: [
      // {
      //   type: "edit",
      //   icon: editIcon,
      //   label: "Edit",
      // },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };
  useEffect(() => {
    fetchJobCardInvoiceList();
  }, []);

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardInvoiceList();
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event?.target?.value);
  };

  const handleOnkeyDownChange = (event) => {
    if (event?.key === "Enter") {
      fetchJobCardInvoiceList();
    }
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-md-4  mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Payment Against Invoice</h5>
        </div>
        <div className="col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              {totalPaymentInvoice?.total || 0}
            </div>
            <div>Total Job</div>
          </div>

          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              &#8377;{totalPaymentInvoice?.total_revenue || 0}
            </div>
            <div>Total </div>
          </div>
          <div
            // key={}
            className="topleftdataContainer "
          >
            <div className="listTopDataValueText ">
              &#8377;{totalPaymentInvoice?.total_approve || 0}
            </div>
            <div>Total Paid </div>
          </div>
          <div
            // key={}
            className=""
          >
            <div className="listTopDataValueText">
              &#8377;{totalPaymentInvoice?.total_pending || 0}
            </div>
            <div>Total Pending</div>
          </div>
        </div>
      </div>

      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView pt-4 col-md-4 gap-2">
            <h5 >Payment Against Invoice List</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={handleOnkeyDownChange}
              />
              {searchTerm ? (
                <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch}
                />
              ) : (
                <img
                  src={searchIcon}
                  alt="Search"
                  className="searchinput-icon"
                />
              )}
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <h5 style={{paddingTop:"30px"}}>Filter By</h5>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            />
          </div>
        </div>
        <CustomTable
          data={jobCardInvoiceData || []}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          totalRecords={totalRecords}
          handleViewButton={handleEdit}
          tableLoaderShow={lodertable}
        />
      </div>
    </div>
  );
};

export default PaymentInvoiceList;
